<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="bank_account_headers"
          :items="external_accounts_list"
          class="elevation-0 mt-2 mb-2 mx-3 light-regular-font"
          :no-data-text="i18n('Nenhum canal bancário registrado')"
          hide-actions
        >
          <template v-slot:items="props">
            <tr @click.stop="toggle_selected(props.item)">
            <td v-if="select_shared_account">
              <v-icon v-if="props.item.selected" class="blue_icon">check_box</v-icon>
              <v-icon v-else class="grey_icon">check_box_outline_blank</v-icon>
            </td>
            <td>{{ props.item.id }}</td>
            <td v-if="show_admin_external_bank_account">{{ props.item.partner_owner_name }}</td>
            <td v-if="show_admin_external_bank_account">{{ props.item.nickname }}</td>
            <td v-if="!onboarding" class="text-xs-left">{{ props.item.bank_name }}</td>
            <td v-else class="text-xs-left">{{ show_bank_name_with_code_or_ispb(props.item.bank) }}</td>
            <td v-if="show_partner_external_bank_accounts || show_partner_facilita_bank_accounts || partner" class="text-xs-center">{{ props.item.bank.swift }}</td>
            <td v-if="!show_partner_external_bank_accounts && !partner" class="text-xs-center">{{ props.item.branch_number }}</td>
            <td class="text-xs-center">{{ props.item.account_number || (props.item.pix_info && props.item.pix_info.key || '') }}</td>
            <td v-if="!select_shared_account && (show_partner_external_bank_accounts || show_facilita_bank_accounts || show_partner_facilita_bank_accounts)" class="text-xs-center">{{ props.item.routing_number }}</td>
            <td class="text-xs-center">{{ props.item.currency }}</td>
            <td v-if="show_facilita_bank_accounts" class="text-xs-center">
              <div
                style="cursor: pointer;"
                v-if="!props.item.internal"
                @click="setAutoScheduleForm(props.item)"
              >
                <div v-if="props.item.exclusive_for">
                  {{ exclusiveFor(props.item).name }}<br>{{ exclusiveFor(props.item).docs }}
                </div>
                <v-icon v-if="!props.item.exclusive_for">add_link</v-icon>
              </div>
            </td>
            <td v-if="show_facilita_bank_accounts" class="text-xs-center">{{ transactionsCountFor(props.item) }}</td>
            <td v-if="show_facilita_bank_accounts" class="text-xs-center">{{ wiresCountFor(props.item) }}</td>
            <td class="text-xs-right px-0">
              <div style="display: flex; justify-content: space-around">
                <v-icon small @click="setUpdateForm(props.item)" style="max-width: 35px;" v-if="display_actions_col(props.item)" > edit </v-icon>
                <div style="max-width: 35px;" v-if="display_actions_col(props.item)">
                  <DeleteModal @onConfirm="deleteBankAccount(props.item)">
                    <v-icon small style="cursor: pointer;">delete</v-icon>
                  </DeleteModal>
                </div>
              </div>
            </td>
            </tr>
          </template>
        </v-data-table>
        <details-dialog
          :addBtn="false"
          :mode="mode"
          :errors="errors"
          :admin="admin"
          :record="selectedBankAccount"
          :dialog="bank_account_dialog"
          :show_partner_external_bank_accounts="show_partner_external_bank_accounts"
          :show_external_bank_accounts="show_external_bank_accounts"
          :subject_document_type="subject_document_type"
          :partner="partner"
          @closeDialog="closeDialog"
          @updateBankAccount="updateBankAccount"
          @createBankAccount="createBankAccount"
        />
        <auto-schedule-modal :accounts="bank_accounts" :sourceBankAccount="selectedBankAccount" :dialog="exclusive_account_dialog" @closeDialog="_e => closeDialog(true)" />
        <v-btn color="#0e9e98de" dark small absolute top right fab @click="setInsertForm" v-if="show_add_button">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="show_more_button" block dark class="ma-0 btn-style" @click="requestMoreRecords">
            {{i18n('Exibir mais')}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import utils from "./shared/Utils"
import banks from "./shared/Banks"
import {local_currencies}  from "./shared/Currencies"
import BankAccountsDialog from "./BankAccountsDialog"
import AutoScheduleModal from "./AutoScheduleModal"
import DeleteModal from "./DeleteModal"

export default {
  name: 'ExternalBankAccounts',
  components: {
    detailsDialog: BankAccountsDialog,
    AutoScheduleModal,
    DeleteModal
  },
  props: {
    bank_accounts: {
      type: Array,
      default: []
    },
    subject_id: {
      type: String
    },
    display_action_columns: {
      type: Boolean,
      default: true
    },
    show_add_button: {
      type: Boolean,
      default: true
    },
    show_more_button: {
      type: Boolean,
      default: false
    },
    show_partner_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_partner_facilita_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_facilita_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_admin_external_bank_account: {
      type: Boolean,
      default: false
    },
    subject_document_type: {
      type: String
    },
    onboarding: {
      type: Boolean,
      default: false
    },
    select_shared_account: {
      type: Boolean,
      default: false
    },
    partner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      banks,
      errors: {},
      admin: false,
      mode: 'insert',
      wiresCount: [],
      transactionsCount: [],
      bank_account_dialog: false,
      exclusive_account_dialog: false,
      localCurrencies: local_currencies,
      bank_account_headers: [
        { text: this.i18n('ID'), value: 'id', align: 'left', sortable: false },
        { text: this.i18n('Banco'), value: 'bank_name', align: 'left', sortable: true },
        { text: this.i18n('Número'), value: 'account_number', align: 'center', sortable: false },
        { text: this.i18n('Moeda'), value: 'currency', align: 'center', sortable: true },
        { text: this.i18n('Ação'), value: 'actions', align: 'center', sortable: false }
      ],
      selectedBankAccount: {
        bank: { name: '', code: '', ispb: '' },
        branch_number: '',
        account_number: '',
        account_type: 'conta-corrente', // conta-corrente / poupanca
        owner_name: '',
        currency: null,
        nickname: '',
        owner_document_number: '',
        owner_document_type: '',
        pix_info: {
          type: '',
          key: ''
        }
      }
    }
  },
  methods: {
    requestMoreRecords() {
      this.$emit('requestMoreRecords')
    },
    i18n(str) {
      return this.$root.l(str)
    },
    closeDialog(can_force_reload = false) {
      this.bank_account_dialog = false
      this.exclusive_account_dialog = false
      this.$emit('onAccountClosed', this.selectedBankAccount, can_force_reload)
    },
    mask(document_type, document_number) {
      return utils.mask(document_type, document_number)
    },
    loadTransactionsCount() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.transactionsCount = response.body.data
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const bank_account_ids = this.bank_accounts.map((b) => { return b.id })
      const payload = {ids: bank_account_ids}

      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__bank_accounts_transactions_count, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadWiresCount() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.wiresCount = response.body.data
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const bank_account_ids = this.bank_accounts.map((b) => { return b.id })
      const payload = {ids: bank_account_ids}

      const token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin__bank_accounts_wires_count, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    transactionsCountFor(bank_account) {
      const i = this.transactionsCount.findIndex(el => el.id === bank_account.id)
      if (i < 0) { return 0 }
      return this.transactionsCount[i].count
    },
    wiresCountFor(bank_account) {
      const i = this.wiresCount.findIndex(el => el.id === bank_account.id)
      if (i < 0) { return 0 }
      return this.wiresCount[i].count
    },
    urlForNewBankAccount() {
      switch(true) {
        case !!this.subject_id && !!this.admin:
          return this.$root.urls.admin__bank_accounts_new
        case !!this.subject_id:
          return this.$root.urls.customer__subject__bank_accounts.split('ID').join((this.subject_id))
        default:
          return this.$root.urls.bank_accounts
      }
    },
    urlForExistingBankAccount(bank_account) {
      return this.admin ?
        `${this.$root.urls.admin__bank_accounts_new}${bank_account.id}` :
          this.subject_id ?
          `${this.$root.urls.customer__subject}${this.subject_id}/bank_accounts/${bank_account.id}` :
          `${this.$root.urls.bank_accounts}${bank_account.id}`
    },
    createBankAccount() {
      let bank_account = { ...this.selectedBankAccount }
      if(bank_account.pix_info && bank_account.pix_info.key == "" && bank_account.pix_info.type == "") {
        delete bank_account.pix_info
      }
      const token = this.$cookies.get('api_token')

      if (bank_account.account_type == 'internacional') {
        bank_account.account_type = 'conta-corrente'
      }

      if (this.localCurrencies.includes(bank_account.currency)) {
        delete bank_account.bank.swift

        let bank_code = bank_account.bank && bank_account.bank.code || ''
        let bank_ispb = bank_account.bank && bank_account.bank.ispb || ''
        if (String(bank_code).trim() === '' && String(bank_ispb).trim() === '') {
          delete bank_account.bank
        }
      } else {
        delete bank_account.bank.code
        delete bank_account.bank.ispb
      }

      bank_account.branch_country = utils.getBranchCountry(bank_account.currency)

      const payload = { bank_account }

      let onSuccess = (bank_account_created) => {
        this.bank_account_dialog = false
        this.resetForm()
        this.$emit('onAccountCreate', bank_account_created)
      }

      let onError = () => {
        console.log(response)
      }

      let successCallback = (response) => {
        if (response.body.data) {
          const bank_account_created = response.body.data
          if (this.admin && this.subject_id) {
            const accountOwnerInfo = {
              bank_account_owner: {
                company_id: this.subject_id,
                bank_account_id: bank_account_created.id
              }
            }
            this.$http.post(
              this.$root.urls.admin__bank_accounts_owners,
              accountOwnerInfo,
              {headers: { Authorization: `Bearer ${token}` }}
            ).then(
              (_response) => onSuccess(bank_account_created),
              (_response) => onError()
            )
          } else {
            onSuccess(bank_account_created)
          }
        } else {
          onError()
        }
      }

      let errorCallback = (response) => {
        if (response.body.errors) {
          let errors = utils.translateErrors(response.body.errors, this.$root.lang)
          this.$set(this, 'errors', errors)
          if (errors.bank && errors.bank.code) this.$set(this.errors, 'bank_code', errors.bank.code)
          if (errors.bank_id) this.$set(this.errors, 'bank_code', errors.bank_id)
          if (errors.bank && errors.bank.ispb) this.$set(this.errors, 'bank_ispb', errors.bank.ispb)
          if (errors.bank && errors.bank.swift) this.$set(this.errors, 'bank_swift', errors.bank.swift)
          if (errors.bank && errors.bank.name) this.$set(this.errors, 'bank_name', errors.bank.name)
          if (errors.code) this.$set(this.errors, 'bank_code', errors.code)
          if (errors.ispb) this.$set(this.errors, 'bank_ispb', errors.ispb)
        }
      }

      let valid = this.validParams(bank_account)

      if(valid && !this.onboarding) {
        const token = this.$cookies.get('api_token')
        let targetUrl = this.urlForNewBankAccount()
        this.$http.post(targetUrl, payload, {headers: { Authorization: `Bearer ${token}` }}).
        then(successCallback, errorCallback)
      }

      if(valid && this.onboarding) {
        this.bank_account_dialog = false
        this.$emit('onAccountCreate', bank_account, this.show_partner_facilita_bank_accounts)
      }
    },
    exclusiveFor(bank_account) {
      if (!bank_account.exclusive_for) { return { name: '', docs: '' } }
      let docs = this.mask(bank_account.exclusive_for.document_type, bank_account.exclusive_for.document_number)
      return { name: bank_account.exclusive_for.social_name, docs }
    },
    is_blank(field) {
      return String(field).trim() == ''
    },
    isCryptoAccount(name){
      return name.split('-').length == 2 &&
          this.validStablecoin(name.split('-')[0]) &&
          this.validCryptoToken(name.split('-')[1])
    },
    isValidCryptoAccountNumber() {
      let account_number = this.selectedBankAccount.account_number
      let crypto_token = this.selectedBankAccount.bank.name.split('-')[1]
      return ((crypto_token == "ERC20" || crypto_token== "BEP20") && account_number.startsWith("0x") && account_number.trim().length == 42) ||
            (crypto_token == "TRC20" && account_number.startsWith("T") && account_number.trim().length == 34)
    },
    validStablecoin(stablecoin) {
      let stablecoin_items = [
          {text: 'USDC', value: 'USDC'},
          {text: 'USDT', value: 'USDT'},
          {text: 'USDG', value: 'USDG'},
          {text: 'RLUSD', value: 'RLUSD'}
        ]
      return stablecoin_items.some(item => item.value === stablecoin);
    },
    validCryptoToken(crypto_token) {
      let crypto_token_items = [
        {text: 'ERC20', value: 'ERC20'},
        {text: 'TRC20', value: 'TRC20'},
        {text: 'BEP20', value: 'BEP20'}
      ]
      return crypto_token_items.some(item => item.value === crypto_token);
    },
    setInsertForm() {
      this.resetForm()
      this.bank_account_dialog = true
    },
    setUpdateForm(bank_account) {
      this.mode = 'update'
      this.errors = {}
      if (!this.localCurrencies.includes(bank_account.currency)){
        bank_account.account_type = 'internacional'
      }

      if(this.onboarding) {
        this.selectedBankAccount = {...bank_account}
      } else {
        this.selectedBankAccount = bank_account
      }
      this.bank_account_dialog = true
    },
    setAutoScheduleForm(bank_account) {
      this.selectedBankAccount = bank_account
      this.exclusive_account_dialog = true
    },
    resetForm() {
      this.selectedBankAccount = {
        bank: { name: '', ispb: '', code: '', swift: '' },
        branch_number: '',
        account_number: '',
        owner_name: '',
        currency: null,
        owner_document_number: '',
        owner_document_type: '',
      }
      this.errors = {}
      this.mode = 'insert'
    },
    updateBankAccount() {
      let bank_account = this.selectedBankAccount
      if (bank_account.account_type == 'internacional') {
        bank_account.account_type = 'conta-corrente'
      }
      if (this.localCurrencies.includes(bank_account.currency)) {
        delete bank_account.bank.swift
      } else {
        delete bank_account.bank.code
        delete bank_account.bank.ispb
      }

      let valid =  this.validParams(bank_account)

      if(valid && this.onboarding) {
        this.resetForm()
        this.bank_account_dialog = false
        this.$emit('onAccountUpdate', bank_account, this.show_partner_facilita_bank_accounts)
      } else if (valid && !this.onboarding) {
        let bank_account_payload = Object.fromEntries(Object.entries(this.selectedBankAccount).filter(([_, v]) => v != null))
        if(bank_account_payload.pix_info && bank_account_payload.pix_info.key == "" && bank_account_payload.pix_info.type == "") {
          delete bank_account_payload.pix_info
        }
        const payload = {
          bank_account: bank_account_payload
          // Filter blank attributes that may crash the backend
        }

        let successCallback = (response) => {
          if (response.body.data) {
            const updated_bank_account = response.body.data;
            this.resetForm()
            this.$emit('onAccountUpdate', updated_bank_account)
            this.bank_account_dialog = false
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = utils.translateErrors(response.body.errors, this.$root.lang)
            this.$set(this, 'errors', errors)
            if (errors.bank && errors.bank.code) this.$set(this.errors, 'bank_code', errors.bank.code)
            if (errors.bank && errors.bank.ispb) this.$set(this.errors, 'bank_ispb', errors.bank.ispb)
            if (errors.bank && errors.bank.swift) this.$set(this.errors, 'bank_swift', errors.bank.swift)
            if (errors.bank && errors.bank.name) this.$set(this.errors, 'bank_name', errors.bank.name)
            if (errors.branch_number) this.$set(this.errors, 'branch_number', errors.branch_number)
            if (errors.account_number) this.$set(this.errors, 'account_number', errors.account_number)
            if (errors.code) this.$set(this.errors, 'bank_code', errors.code)
            if (errors.ispb) this.$set(this.errors, 'bank_ispb', errors.ispb)
          }
        }

        this.errors = {}
        const token = this.$cookies.get('api_token')
        const url = this.urlForExistingBankAccount(bank_account)

        this.$http.put(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      }
    },
    deleteBankAccount(bank_account) {

      if(this.onboarding) {
        this.$emit('onAccountDelete', bank_account, this.show_partner_facilita_bank_accounts)
      } else {
        let successCallback = (response) => {
          this.$emit('onAccountDelete', bank_account)
        }

        let errorCallback = (response) => {
          console.log('errorCallback', response)
        }

        const token = this.$cookies.get('api_token')
        const url = this.urlForExistingBankAccount(bank_account)

        this.$http.delete(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      }
    },
    display_actions_col(item) {
      return !item.internal && this.display_action_columns
    },
    validParams(bank_account) {
      this.errors = {}

      let valid = true

      if (bank_account.currency == 'BRL') {
        if (this.is_blank(this.selectedBankAccount.bank.name) && this.is_blank(this.selectedBankAccount.pix_info.key)) {
          this.$set(this.errors, 'bank_name', this.i18n('Obrigatório'))
          valid = false
        }

        if (
          this.is_blank(this.selectedBankAccount.bank.code) &&
          this.is_blank(this.selectedBankAccount.bank.ispb) &&
          this.is_blank(this.selectedBankAccount.pix_info.key)) {
          this.$set(this.errors, 'bank_code', this.i18n('Obrigatório código ou ISPB do banco'))
          this.$set(this.errors, 'bank_ispb', this.i18n('Obrigatório código ou ISPB do banco'))
          valid = false
        }
        if (this.is_blank(this.selectedBankAccount.branch_number) && this.is_blank(this.selectedBankAccount.pix_info.key)) {
          this.$set(this.errors, 'branch_number', this.i18n('Obrigatório'))
          valid = false
        }
        if (this.selectedBankAccount.pix_info.key && this.is_blank(this.selectedBankAccount.pix_info.type)) {
          this.$set(this.errors, 'pix_type', this.i18n('Obrigatório'))
          valid = false
        } else if (this.selectedBankAccount.pix_info.type && this.is_blank(this.selectedBankAccount.pix_info.key)) {
          this.$set(this.errors, 'pix_key', this.i18n('Obrigatório'))
          valid = false
        }
      } else {
        if (String(this.selectedBankAccount.bank.name).trim() == '') {
          this.$set(this.errors, 'bank_name', this.i18n('Obrigatório'))
          valid = false
        }
        if (String(this.selectedBankAccount.bank.swift).trim() == '') {
          this.$set(this.errors, 'bank_swift', this.i18n('Obrigatório'))
          valid = false
        }
      }
      if(this.localCurrencies.filter((currency) => currency != "BRL").indexOf(this.selectedBankAccount.currency) != -1 && this.is_blank(this.selectedBankAccount.bank.code)) {
          this.$set(this.errors, 'bank_code', this.i18n('Obrigatório'))
          valid = false
      }
      if (String(this.selectedBankAccount.account_number).trim() == '' && this.is_blank(this.selectedBankAccount.pix_info.key)) {
        this.$set(this.errors, 'account_number', this.i18n('Obrigatório'))
        valid = false
      }

      if(valid && this.isCryptoAccount(this.selectedBankAccount.bank.name) &&  !this.isValidCryptoAccountNumber()) {
        this.$set(this.errors, 'account_number', this.i18n('Formato inválido'))
        valid = false
      }

      return valid
    },
    build_facilita_bank_account_headers() {
      this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Agência', new_object_value: 'branch_number', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'account_number', new_object_text: 'Routing', new_object_value: 'routing_number', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'currency', new_object_text: 'Exclusiva', new_object_value: 'exclusive_for', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'exclusive_for', new_object_text: 'Transações', new_object_value: 'transactions', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'transactions', new_object_text: 'Transferências', new_object_value: 'wires', new_object_align: 'center'})
    },
    build_partner_subject_external_bank_account_headers() {
      this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Agência', new_object_value: 'branch_number', new_object_align: 'center'})
    },
    build_admin_company_external_bank_account_headers() {
      this.add_column_into_bank_account_headers({reference_onject_value: 'id', new_object_text: 'Parceiro', new_object_value: 'partner', new_object_align: 'left'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'partner', new_object_text: 'Apelido', new_object_value: 'nickname', new_object_align: 'left'})
      if (this.partner) {
        this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Swift', new_object_value: 'swift', new_object_align: 'center'})
      } else {
        this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Agência', new_object_value: 'branch_number', new_object_align: 'center'})
      }
    },
    build_partner_external_bank_account_headers() {
      this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Swift', new_object_value: 'swift', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'account_number', new_object_text: 'Routing', new_object_value: 'routing_number', new_object_align: 'center'})
    },
    build_partner_facilita_bank_account_headers() {
      this.add_column_into_bank_account_headers({reference_onject_value: 'bank_name', new_object_text: 'Swift', new_object_value: 'swift', new_object_align: 'center'})
      this.add_column_into_bank_account_headers({reference_onject_value: 'swift', new_object_text: 'Agência', new_object_value: 'branch_number', new_object_align: 'center'})
      if (this.select_shared_account) {
        this.bank_account_headers.splice(0, 0, { text: '', value: 'select_toggle', align: 'center', sortable: false })
      } else {
        this.add_column_into_bank_account_headers({reference_onject_value: 'account_number', new_object_text: 'Routing', new_object_value: 'routing_number', new_object_align: 'center'})
      }
      this.bank_account_headers = this.bank_account_headers.filter(item => item.value !== 'actions');
    },
    add_column_into_bank_account_headers(attrs) {
      const index = this.bank_account_headers.findIndex(el => el.value === attrs.reference_onject_value) + 1
      this.bank_account_headers.splice(index, 0, { text: this.i18n(attrs.new_object_text), value: attrs.new_object_value, align: attrs.new_object_align, sortable: false })
    },
    show_bank_name_with_code_or_ispb(bank) {
      if (bank.code) return bank.code + ' - ' + bank.name
      if (bank.ispb) return bank.ispb + ' - ' + bank.name

      return bank.name
    },
    toggle_selected(bank_account) {
      if (this.select_shared_account) {
        this.$emit('onToggleSelected', bank_account)
      }
    }
  },
  watch: {
    'selectedBankAccount.account_type'(val, old_val) {
      if (val != old_val) {
        if (this.mode == 'insert') {
          if (val == 'internacional') {
            this.selectedBankAccount.currency = 'USD'
          } else {
            this.selectedBankAccount.currency = null
          }
        }
      }
    }
  },
  computed: {
    external_accounts_list() {
      if(this.onboarding) {
        return [...this.bank_accounts]
      } else {
        return this.bank_accounts.filter(( record ) => { return !record.internal })
      }
    }
  },
  mounted() {
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'

    if (this.show_facilita_bank_accounts) {
      this.loadTransactionsCount()
      this.loadWiresCount()
      this.build_facilita_bank_account_headers()
    } else if (this.show_external_bank_accounts && !this.show_admin_external_bank_account) {
      this.build_partner_subject_external_bank_account_headers()
    } else if (this.show_external_bank_accounts && this.show_admin_external_bank_account) {
      this.build_admin_company_external_bank_account_headers()
    } else if (this.show_partner_external_bank_accounts) {
      this.build_partner_external_bank_account_headers()
    } else if (this.show_partner_facilita_bank_accounts) {
      this.build_partner_facilita_bank_account_headers()
    }
  },

}
</script>

<style>
  .v-icon.blue_icon {
    color: #37517e;
  }
  .v-icon.grey_icon {
    color: #CCC;
  }
</style>



// WEBPACK FOOTER //
// src/ExternalBankAccounts.vue